function PopularResorts($element) {
    this._$element = $element;

    if (!this._$element) {
        return;
    }

    // кнопка загрузки
    this._$button = this._$element.querySelector('.js-popularResortsButton');
    this._$list   = this._$element.querySelector('.js-popularResortsList');

    if (this._$button) {
        this._$button.addEventListener('click', e => {
            if (this._$button.classList.contains('loading')) {
                return;
            }

            if (this._$button.classList.contains('hide-mode')) {
                const items = Array.from(this._$list.children);
                items.slice(6).forEach(item => item.remove());
                this._$button.textContent = 'Загрузить ещё';
                this._$button.classList.remove('hide-mode');
                this._$element.dataset.page = 1;

                this._$element.scrollIntoView({behavior: 'instant', block: 'start'});
                return;
            }

            this._$button.classList.add('loading');

            const params = [];
            for (let name in this._$element.dataset) {
                if (name == 'page') {
                    this._$element.dataset[name] = parseInt(this._$element.dataset[name], 10) + 1;
                }

                const value = this._$element.dataset[name];
                params.push({name, value});
            }

            const query = params.map(({name, value}) => `${name}=${encodeURIComponent(value)}`).join('&');

            fetch('/main/popular_cities_block/?' + query, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
                .then(response => response.json())
                .then(r => {
                    if (r.status != 'ok') {
                        throw new Error(r);
                    }

                    this._$list.insertAdjacentHTML('beforeend', r.content || '');

                    if (!r.more) {
                        this._$button.textContent = 'Скрыть всё';
                        this._$button.classList.add('hide-mode');
                    }
                }).catch(e => {
                console.error('Ошибка:', e);
            }).finally(() => {
                this._$button.classList.remove('loading');
            });
        });
    }
}

export default PopularResorts;
